module.exports = __webpack_public_path__ + "9f01c98bf55cdb198d971b874f582df2.MP3";